<template>
  <div
    class="modal fade"
    id="ViewEvent"
    tabindex="-1"
    aria-labelledby="ViewEventLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="ViewEventLabel">
            View Event Details
          </h5>
          <button
            type="button"
            class="btn-close"
            id="ViewEventClose"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="event-details">
            <h4 class="mb-4">{{ simpleScheduledEvent.name }}</h4>

            <div class="detail-row mb-3">
              <strong>Date:</strong> {{ getEventDate }}
            </div>

            <div class="detail-row mb-3">
              <strong>Time:</strong>
              {{
                new Date(`2000-01-01T${schedule.startTime}`).toLocaleTimeString(
                  [],
                  { hour: 'numeric', minute: '2-digit', hour12: true }
                )
              }}
              -
              {{
                new Date(`2000-01-01T${schedule.endTime}`).toLocaleTimeString(
                  [],
                  { hour: 'numeric', minute: '2-digit', hour12: true }
                )
              }}
            </div>

            <div class="detail-row mb-3" v-if="simpleScheduledEvent.location">
              <strong>Location:</strong> {{ simpleScheduledEvent.location }}
            </div>

            <div class="detail-row">
              <strong>Description:</strong>
              <p class="mt-2">{{ simpleScheduledEvent.description }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="this.simpleScheduledEvent.isCamp"
            type="button"
            class="w-full flex items-center justify-center gap-2 bg-[#363166] hover:bg-[#423d7d] text-white py-3 px-6 font-medium transition-colors duration-200 custom-button !text-xl"
            :style="{
              backgroundColor:
                '#' + $route.params.primaryColor || '19d412' + ' !important',
            }"
            @click="handleSignUp"
          >
            Sign up
          </button>
          <div v-if="filteredMemberships.length > 0" class="w-full">
            <button
              v-for="membership in filteredMemberships"
              :key="membership._id"
              type="button"
              class="w-full flex items-center justify-center gap-2 bg-[#363166] hover:bg-[#423d7d] text-white py-3 px-6 font-medium transition-colors duration-200 custom-button !text-xl mt-3"
              :style="{
                backgroundColor:
                  '#' + $route.params.primaryColor || '19d412' + ' !important',
                width: '100%',
                display: 'block',
              }"
              @click="handleBuyMembership(membership)"
            >
              {{ membership.membershipName }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  components: {},
  data() {
    return {
      dayApplicable: 'TODAY',
      addressVerified: true,
    }
  },
  props: {
    simpleScheduledEvent: Object,
    schedule: Object,
    userID: String,
    memberships: Array,
  },
  methods: {
    handleSignUp() {
      document.getElementById('ViewEventClose').click()
      this.$router.push({
        path: `/coach/${this.$route.params.coachId}/${this.$route.params.primaryColor}/${this.$route.params.secondaryColor}/viewPayment/${this.simpleScheduledEvent.campID}`,
      })
    },
    handleBuyMembership(membership) {
      document.getElementById('ViewEventClose').click()
      this.$router.push({
        path: `/coach/${this.$route.params.coachId}/${this.$route.params.primaryColor}/${this.$route.params.secondaryColor}/viewPayment/${membership._id}`,
      })
    },
  },
  computed: {
    getEventDate() {
      return this.schedule.date
    },
    filteredMemberships() {
      if (!this.simpleScheduledEvent.membershipIds || !this.memberships.length)
        return []
      return this.memberships.filter(membership =>
        this.simpleScheduledEvent.membershipIds.includes(membership._id)
      )
    },
  },
  created() {},
  mounted() {},
}
</script>
  
<style scoped>
.event-details {
  padding: 0 1rem;
}

.detail-row {
  line-height: 1.5;
}

.detail-row p {
  white-space: pre-line;
}

.custom-button {
  border-radius: 8px !important;
  -webkit-border-radius: 8px !important;
  -moz-border-radius: 8px !important;
}

.custom-button:hover {
  filter: brightness(0.95) !important;
}
</style>
  